// src/store/rfqStore.js
import create from 'zustand';
import { persist } from 'zustand/middleware';

const rfqStore = create(persist(
    (set) => ({
        mockRfqs: [],
        addRfq: (newRfq) => set((state) => ({
            mockRfqs: [...state.mockRfqs, newRfq]
        })),
        
        mockProposals: [],
        addProposal: (newProposal) => set((state) => ({
            mockProposals: [...state.mockProposals, newProposal]
        })),
        // ------------------------------------

        clearAllMocks: () => set({ mockRfqs: [], mockProposals: [] })
    }),
    {
        name: 'rfq-test-storage',
    }
));

export default rfqStore;